<template>
  <router-link :to="{ name: 'budgets.overview', params: { budget_id: budget.id } }">
    <div class="row">
      <div class="col-12 col-lg-5">
        <p class="text-truncate">
          <span class="strong">{{ budget.name }}</span><br/>
          <span class="d-inline-block mt-1">{{ budget.client ? budget.client.company : '' }}</span>
        </p>
      </div>
      <div class="col-4 col-lg-2">
        <p>
          <span class="data-label d-lg-none">Balance:</span>
          {{ budget.balance }} hrs
        </p>
      </div>
      <div class="col-4 col-lg-2">
        <p>
          <span class="data-label d-lg-none">Budget:</span>
          {{ budget.budget }} hrs
        </p>
      </div>
      <div class="col-4 col-lg-2">
        <p>
          <span class="data-label d-lg-none">Spent:</span>
          {{ budget.spent }} hrs
        </p>
      </div>
      <div class="col-12 col-lg-1 text-lg-end">
        <span class="status" :class="budget.deleted_at ? 'status-default' : 'status-primary'">
          {{ budget.deleted_at ? 'Archived' : budget.status }}
        </span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    budget: {
      required: true,
      type: Object
    }
  }
}
</script>
